
module.exports = {
  // TODO: change your profile information here
  name: "Snehasish Dhar",
  greeting: "Hey 👋",
  greetingDescription: "I'm Snehasish Dhar and I'm a CS undergrad,Full Stack Developer",
  githubUrl: "https://github.com/dsnehasish74",
  linkedinUrl: "https://www.linkedin.com/in/snehasish-dhar-b657721a0/",
  cvLink: "https://docs.google.com/document/d/1q8RxN7B7Uo_1FN_RBLKwH3GlxiC0x67hyftOyDBQ_l8/edit?usp=sharing",
};
